import config from '../utils/config';
import { getLocalStorage } from '../utils/func';

// Optional engagement requests fail silently in the coordinator, never block
// the feed, and never retry a non-idempotent claim behind the user's back.
export async function inAppRequest(path, { method = 'GET', body, signal, token = getLocalStorage(config.token) } = {}) {
  if (!token || token !== getLocalStorage(config.token)) throw new Error('IN_APP_SESSION_CHANGED');
  const controller = new AbortController();
  const abort = () => controller.abort();
  if (signal?.aborted) abort();
  signal?.addEventListener('abort', abort, { once: true });
  const timeout = setTimeout(abort, 8000);
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/in-app${path}`, {
      method, signal: controller.signal, cache: 'no-store',
      headers: { 'Content-Type': 'application/json', [config.token]: token },
      ...(body === undefined ? {} : { body: JSON.stringify(body) }),
    });
    const data = await response.json();
    if (!response.ok || data.success !== true || token !== getLocalStorage(config.token)) throw new Error('IN_APP_UNAVAILABLE');
    return data;
  } finally { clearTimeout(timeout); signal?.removeEventListener('abort', abort); }
}
